<template lang="pug">
.list
  el-upload.upload-file(
    ref="upload",
    v-loading="loading",
    :http-request="httpRequest",
    :before-upload="beforeUpload",
    drag,
    accept=".xlsx,.xls",
    :show-file-list="false",
    action="/"
  )
    .uploaderButton
      i.el-icon-upload
      span 点击或者拖动文件到虚线框内上传
      .tips 支持 xls,xlsx 等类型的文件
  .upTips
    h4 上传的 Excel 表符合以下规范:
    h4
      span · 文件大小不超过
      span.blob 10M
      span 当发校验规则、关联业务规则和第三方服务回调时，单个sheet页数据量不超过 5000行
    h4
      span · 仅支持 (
      span.blob xls 和*xlsx
      span ) 文件
    h4 · 请确保需要导入的excel: 不含合并单元格、sheet表头不含空单元格
</template>

<script>
import { mapState } from "vuex";
import { serveReadExcel } from "./api.js";
export default {
  props: {
    tableName: {
      type: String,
      default: "LeaveFlow"
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  methods: {
    async httpRequest({ file }) {
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      try {
        const { data } = await serveReadExcel(formData);
        this.$emit("uploaderInfo", data);
      } finally {
        this.loading = false;
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$warn("大小不能超过 10M");
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-file {
  width: 100%;
}
/deep/.el-upload {
  width: 100%;
}
/deep/.el-upload-dragger {
  width: 100%;
  height: 100%;
  .el-icon-upload {
    font-size: 50px;
    margin-top: 20px;
  }
}
.uploaderButton {
  width: 100%;
  height: 150px;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  span {
    font-size: 16px;
    font-weight: 600;
  }
  .tips {
    margin-top: 5px;
    font-size: 14px;
    color: #d4d4d4;
  }
}
.demo {
  margin-top: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 14px;
    font-weight: 700;
  }
  i {
    font-size: 16px;
  }
  .down {
    margin-left: 5px;
    color: #4777e7;
    cursor: pointer;
  }
}
.upTips {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
h4 {
  color: var(--info-color);
  line-height: 25px;
}
.blob {
  color: #000;
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 700;
}
</style>
